import Vue from 'vue'
import Router from 'vue-router'

import twSignup from '@/web/signup'
import tw404 from '@/web/404'
import twFindPassword from '@/web/find_password'

// // 中心相关路由
import twDocComponent from '@/web/doc/component' // 公共页面
import twDocSearch from '@/web/doc/search' // 查询页面
import Doc from '@/components/tw-doc'
// import twIntroduceLeft from '@/web/doc/introduce-left'
// import twDesignLeft from '@/web/doc/design-left'
// import twEcrLeft from '@/web/doc/ecr-left'

// import twIntegrateQuick from '@/web/doc/integrate-quick'
// import twIntegrateFrame from '@/web/doc/integrate-frame'
// import twIntegrateApi from '@/web/doc/integrate-api'
// import twIntegrateFaq from '@/web/doc/integrate-faq'
// import twIntegrate from '@/web/doc/integrate-top' // 应用集成页
// import twManualBook from '@/web/doc/integrate-manualbook' // 操作手册页
// import twManualBookFaq from '@/web/doc/manualbook-faq' // 操作手册-FAQ
// import twXtbgFrame from '@/web/doc/xtbg-frame' // 协同办公
// import twWjdcFrame from '@/web/doc/wjdc-frame' // 问卷调查
import twMenuManage from '@/web/doc/document-menu'
// 以下为临时的样式页路由，发布版本中请删除
import style from '@/web/style'

// import utils from '@/config/cookieUtils'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Doc,
      name: 'Doc'
    },
    // {
    //   path: '/introduce',
    //   component: twIntroduceLeft,
    //   redirect: '/introduce/scene',
    //   children: [
    //     {
    //       path: '/introduce/scene',
    //       name: 'TWPAAS1200000000000',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/introduce/overview',
    //       name: 'TWPAAS1200000000001',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/introduce/noun',
    //       name: 'TWPAAS1200000000002',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/introduce/log',
    //       name: 'TWPAAS1200000000003',
    //       component: twDocComponent
    //     }
    //   ]
    // },
    // {
    //   path: '/manualbook',
    //   component: twManualBook,
    //   redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/manualbook/faq/login' : '/manualbook/faq/login',
    //   children: [
    //     {
    //       path: 'faq',
    //       component: twManualBookFaq,
    //       redirect: '/manualbook/faq/login',
    //       children: [
    //         {
    //           path: '/manualbook/faq/login',
    //           name: 'TWMBOOK1200000000001',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/faq/findpwd',
    //           name: 'TWMBOOK1200000000002',
    //           component: twDocComponent
    //         }
    //       ]
    //     },
    //     // 问卷调查
    //     {
    //       path: 'wjdc',
    //       component: twWjdcFrame,
    //       redirect: '/manualbook/wjdc/wjcjwj',
    //       children: [
    //         {
    //           path: '/manualbook/wjdc/wjcjwj',
    //           name: 'TWMBOOK1400000000001',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjsjwj',
    //           name: 'TWMBOOK1400000000002',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjsz',
    //           name: 'TWMBOOK1400000000003',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjwgsz',
    //           name: 'TWMBOOK1400000000004',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/fbwj',
    //           name: 'TWMBOOK1400000000005',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjhswj',
    //           name: 'TWMBOOK1400000000006',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjfxxz',
    //           name: 'TWMBOOK1400000000007',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/tjfxxz',
    //           name: 'TWMBOOK1400000000008',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/ckxzdj',
    //           name: 'TWMBOOK1400000000009',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjfz',
    //           name: 'TWMBOOK1400000000010',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjsc',
    //           name: 'TWMBOOK1400000000011',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/wjdc/wjzx',
    //           name: 'TWMBOOK1400000000012',
    //           component: twDocComponent
    //         }
    //       ]
    //     },
    //     // 协同办公
    //     {
    //       path: 'xtbg',
    //       component: twXtbgFrame,
    //       redirect: '/manualbook/xtbg/login',
    //       children: [
    //         {
    //           path: '/manualbook/xtbg/login',
    //           name: 'TWMBOOK1300000000001',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/zyjs',
    //           name: 'TWMBOOK1300000000002',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/czwdxz',
    //           name: 'TWMBOOK1330000000002',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/dzgrzy',
    //           name: 'TWMBOOK1300000000003',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/glbmyhxx',
    //           name: 'TWMBOOK1300000000004',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kqgzsz',
    //           name: 'TWMBOOK1300000000005',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/lcfqxj',
    //           name: 'TWMBOOK1300000000006',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/wddb',
    //           name: 'TWMBOOK1300000000007',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/jbgz',
    //           name: 'TWMBOOK1300000000008',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/lscx',
    //           name: 'TWMBOOK1300000000009',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/xzbg',
    //           name: 'TWMBOOK1300000000010',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/grrwzy',
    //           name: 'TWMBOOK1300000000011',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/rwxm',
    //           name: 'TWMBOOK1300000000012',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/rwdt',
    //           name: 'TWMBOOK1300000000013',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/cjwj',
    //           name: 'TWMBOOK1300000000014',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/hswj',
    //           name: 'TWMBOOK1300000000015',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/wjcx',
    //           name: 'TWMBOOK1300000000016',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/ckwjdt',
    //           name: 'TWMBOOK1300000000017',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/txwj',
    //           name: 'TWMBOOK1300000000018',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmgnjs',
    //           name: 'TWMBOOK1300000000019',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmqxqb',
    //           name: 'TWMBOOK1300000000020',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmdlfs',
    //           name: 'TWMBOOK1300000000021',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmsy',
    //           name: 'TWMBOOK1300000000022',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmgrwp',
    //           name: 'TWMBOOK1300000000023',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/kmggwp',
    //           name: 'TWMBOOK1300000000024',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/xxrk',
    //           name: 'TWMBOOK1300000000025',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/xtxx',
    //           name: 'TWMBOOK1300000000026',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/yhxx',
    //           name: 'TWMBOOK1300000000027',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/manualbook/xtbg/xxgg',
    //           name: 'TWMBOOK1300000000028',
    //           component: twDocComponent
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: '/integrate',
    //   component: twIntegrate,
    //   redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/quick/account' : '/integrate/frame/config',
    //   children: [
    //     {
    //       path: 'quick',
    //       component: twIntegrateQuick,
    //       redirect: '/integrate/quick/account',
    //       children: [
    //         {
    //           path: '/integrate/quick/account',
    //           name: 'TWPAAS1200000000004',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/quick/createApp',
    //           name: 'TWPAAS1200000000005',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/quick/tools',
    //           name: 'TWPAAS1200000000006',
    //           component: twDocComponent
    //         }
    //       ]
    //     },
    //     {
    //       path: 'frame',
    //       component: twIntegrateFrame,
    //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/frame/readme' : '/integrate/frame/config',
    //       children: [
    //         {
    //           path: '/integrate/frame/readme',
    //           name: 'TWPAAS1200000000007',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/construct',
    //           name: 'TWPAAS1200000000008',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/config',
    //           name: 'TWPAAS1200000000009',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/safe',
    //           name: 'TWPAAS1200000000010',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/log',
    //           name: 'TWPAAS1200000000011',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/logCollection',
    //           name: 'TWPAAS1200000000012',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/task',
    //           name: 'TWPAAS1200000000013',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/excel',
    //           name: 'TWPAAS1200000000014',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/encrypt',
    //           name: 'TWPAAS1200000000015',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/streamingMedia',
    //           name: 'TWPAAS1200000000016',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/upload',
    //           name: 'TWPAAS1200000000017',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/richText',
    //           name: 'TWPAAS1200000000018',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/onlineText',
    //           name: 'TWPAAS1200000000019',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/power',
    //           name: 'TWPAAS1200000000020',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/frame/behaviorCollection',
    //           name: 'TWPAAS1200000000021',
    //           component: twDocComponent
    //         }
    //       ]
    //     },
    //     {
    //       path: 'api',
    //       component: twIntegrateApi,
    //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/api/readme' : '/integrate/api/authentication',
    //       children: [
    //         {
    //           path: '/integrate/api/readme',
    //           name: 'TWPAAS1200000000022',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/openApiSummary',
    //           name: 'TWPAAS1200000000023',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/debug',
    //           name: 'TWPAAS1200000000024',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/identitySummary',
    //           name: 'TWPAAS1200000000025',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/authentication',
    //           name: 'TWPAAS1200000000026',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/sso',
    //           name: 'TWPAAS1200000000027',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/wxqqLogin',
    //           name: 'TWPAAS1200000000107',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/apiSummary',
    //           name: 'TWPAAS1200000000028',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/authorize',
    //           name: 'TWPAAS1200000000029',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/token',
    //           name: 'TWPAAS1200000000030',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/refreshToken',
    //           name: 'TWPAAS1200000000031',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/userList',
    //           name: 'TWPAAS1200000000032',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getUserByToken',
    //           name: 'TWPAAS1200000000033',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/userInfo',
    //           name: 'TWPAAS1200000000034',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/checkUserRepeat',
    //           name: 'TWPAAS1200000000035',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getUserOrgList',
    //           name: 'TWPAAS1200000000036',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/org',
    //           name: 'TWPAAS1200000000037',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/joinSearchSchools',
    //           name: 'TWPAAS1200000000038',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getSchool',
    //           name: 'TWPAAS1200000000039',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryTermList',
    //           name: 'TWPAAS1200000000040',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryTimetableList',
    //           name: 'TWPAAS1200000000041',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/joinSearchClasses',
    //           name: 'TWPAAS1200000000042',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getClass',
    //           name: 'TWPAAS1200000000043',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryTeachers',
    //           name: 'TWPAAS1200000000044',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getTeacherInfo',
    //           name: 'TWPAAS1200000000045',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryTeachs',
    //           name: 'TWPAAS1200000000046',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryStudents',
    //           name: 'TWPAAS1200000000047',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getStudentInfo',
    //           name: 'TWPAAS1200000000048',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryParentList',
    //           name: 'TWPAAS1200000000049',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getParentInfo',
    //           name: 'TWPAAS1200000000050',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryDictTypeList',
    //           name: 'TWPAAS1200000000051',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryDictItemList',
    //           name: 'TWPAAS1200000000052',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryCurriculumWeekList',
    //           name: 'TWPAAS1200000000053',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryCurriculumDayList',
    //           name: 'TWPAAS1200000000054',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryBuildingList',
    //           name: 'TWPAAS1200000000055',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryClassroomList',
    //           name: 'TWPAAS1200000000056',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/searchAttendance',
    //           name: 'TWPAAS1200000000057',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/saveMessage',
    //           name: 'TWPAAS1200000000058',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/unReadMsgCount',
    //           name: 'TWPAAS1200000000059',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/msgList',
    //           name: 'TWPAAS1200000000060',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/sessionList',
    //           name: 'TWPAAS1200000000061',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/sessionView',
    //           name: 'TWPAAS1200000000062',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/setReaded',
    //           name: 'TWPAAS1200000000063',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/deleteMessage',
    //           name: 'TWPAAS1200000000064',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/deleteSession',
    //           name: 'TWPAAS1200000000065',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/unReadMsgList',
    //           name: 'TWPAAS1200000000066',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/integrateJava',
    //           name: 'TWPAAS1200000000067',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/integrateSpringCloud',
    //           name: 'TWPAAS1200000000068',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/upload',
    //           name: 'TWPAAS1200000000069',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/download',
    //           name: 'TWPAAS1200000000070',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/convert',
    //           name: 'TWPAAS1200000000071',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getQuestionList',
    //           name: 'TWPAAS1200000000072',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/getQuestionInfo',
    //           name: 'TWPAAS1200000000073',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/translate',
    //           name: 'TWPAAS1200000000074',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/recognition',
    //           name: 'TWPAAS1200000000075',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/synthesis',
    //           name: 'TWPAAS1200000000076',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/ocr',
    //           name: 'TWPAAS1200000000077',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/clientIntegrate',
    //           name: 'TWPAAS1200000000078',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/acessAuth',
    //           name: 'TWPAAS1200000000079',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/updateAuth',
    //           name: 'TWPAAS1200000000080',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/revokeAuth',
    //           name: 'TWPAAS1200000000081',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/applyTask',
    //           name: 'TWPAAS1200000000082',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/updateTask',
    //           name: 'TWPAAS1200000000083',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/enableTask',
    //           name: 'TWPAAS1200000000084',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/romoveTask',
    //           name: 'TWPAAS1200000000085',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryTask',
    //           name: 'TWPAAS1200000000086',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/statuses',
    //           name: 'TWPAAS1200000000087',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/comment',
    //           name: 'TWPAAS1200000000088',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/visit',
    //           name: 'TWPAAS1200000000089',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/kafka',
    //           name: 'TWPAAS1200000000090',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/sdk',
    //           name: 'TWPAAS1200000000091',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/errorCodeStandard',
    //           name: 'TWPAAS1200000000092',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/errorCodeList',
    //           name: 'TWPAAS1200000000093',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/addGoods',
    //           name: 'TWPAAS1200000000108',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/modifyGoods',
    //           name: 'TWPAAS1200000000109',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryGoods',
    //           name: 'TWPAAS1200000000110',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/saveOrder',
    //           name: 'TWPAAS1200000000111',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/cancelOrder',
    //           name: 'TWPAAS1200000000112',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/queryOrder',
    //           name: 'TWPAAS1200000000113',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/api/payment',
    //           name: 'TWPAAS1200000000114',
    //           component: twDocComponent
    //         }
    //       ]
    //     },
    //     {
    //       path: 'faq',
    //       component: twIntegrateFaq,
    //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/faq/apiQuestion' : '/integrate/faq/accessQuestion',
    //       children: [
    //         {
    //           path: '/integrate/faq/apiQuestion',
    //           name: 'TWPAAS1200000000094',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/faq/accessQuestion',
    //           name: 'TWPAAS1200000000095',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/faq/userQuestion',
    //           name: 'TWPAAS1200000000096',
    //           component: twDocComponent
    //         },
    //         {
    //           path: '/integrate/faq/businessQuestion',
    //           name: 'TWPAAS1200000000097',
    //           component: twDocComponent
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: '/ecr',
    //   component: twEcrLeft,
    //   redirect: '/ecr/base/xkdhjk',
    //   children: [
    //     {
    //       path: '/ecr/base/xkdhjk',
    //       name: 'TWECR0000000000001',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqxkjk',
    //       name: 'TWECR0000000000002',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqxdjk',
    //       name: 'TWECR0000000000003',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqnjjk',
    //       name: 'TWECR0000000000004',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqbbjk',
    //       name: 'TWECR0000000000005',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqcbjk',
    //       name: 'TWECR0000000000006',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqzylxjk',
    //       name: 'TWECR0000000000007',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqtxjk',
    //       name: 'TWECR0000000000008',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqsjlxjk',
    //       name: 'TWECR0000000000009',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqsblbjk',
    //       name: 'TWECR0000000000010',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqzjmljk',
    //       name: 'TWECR0000000000011',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/base/hqzsdmljk',
    //       name: 'TWECR0000000000012',
    //       component: twDocComponent
    //     },
    //     // 资源中心接口
    //     {
    //       path: '/ecr/resource/zyscjk',
    //       name: 'TWECR1000000000001',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/resource/zyxzjk',
    //       name: 'TWECR1000000000002',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/resource/hqzyxqjk',
    //       name: 'TWECR1000000000003',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/resource/hqspkczylbjk',
    //       name: 'TWECR1000000000004',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/resource/hqzylbjk',
    //       name: 'TWECR1000000000005',
    //       component: twDocComponent
    //     },
    //     // 运营中心
    //     {
    //       path: '/ecr/yyzx/yhtjscjk',
    //       name: 'TWECR2000000000001',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/yyzx/yhdzqxdzjk',
    //       name: 'TWECR2000000000002',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/ecr/yyzx/hqsclbjk',
    //       name: 'TWECR2000000000003',
    //       component: twDocComponent
    //     }
    //   ]
    // },
    // {
    //   path: '/design',
    //   component: twDesignLeft,
    //   redirect: '/design/summary',
    //   children: [
    //     {
    //       path: '/design/summary',
    //       name: 'TWPAAS1200000000098',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/concise',
    //       name: 'TWPAAS1200000000099',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/flexible',
    //       name: 'TWPAAS1200000000100',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/control',
    //       name: 'TWPAAS1200000000101',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/layout',
    //       name: 'TWPAAS1200000000102',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/color',
    //       name: 'TWPAAS1200000000103',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/font',
    //       name: 'TWPAAS1200000000104',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/icon',
    //       name: 'TWPAAS1200000000105',
    //       component: twDocComponent
    //     },
    //     {
    //       path: '/design/button',
    //       name: 'TWPAAS1200000000106',
    //       component: twDocComponent
    //     }
    //   ]
    // },
    {
      path: '/search',
      name: 'searchDocument',
      component: twDocSearch
    },
    {
      path: '/MenuManage',
      component: twMenuManage,
      redirect: '/MenuManage/summary',
      children: [
        {
          path: '/MenuManage/summary',
          name: 'TWPAAS1200000000098',
          component: twDocComponent
        },
        {
          path: '/MenuManage/concise',
          name: 'TWPAAS1200000000099',
          component: twDocComponent
        },
        {
          path: '/MenuManage/flexible',
          name: 'TWPAAS1200000000100',
          component: twDocComponent
        },
        {
          path: '/MenuManage/control',
          name: 'TWPAAS1200000000101',
          component: twDocComponent
        },
        {
          path: '/MenuManage/layout',
          name: 'TWPAAS1200000000102',
          component: twDocComponent
        },
        {
          path: '/MenuManage/color',
          name: 'TWPAAS1200000000103',
          component: twDocComponent
        },
        {
          path: '/MenuManage/font',
          name: 'TWPAAS1200000000104',
          component: twDocComponent
        },
        {
          path: '/MenuManage/icon',
          name: 'TWPAAS1200000000105',
          component: twDocComponent
        },
        {
          path: '/MenuManage/button',
          name: 'TWPAAS1200000000106',
          component: twDocComponent
        }
      ]
    },
    {
      path: '/signup',
      component: twSignup
    },
    {
      path: '/find_password',
      component: twFindPassword
    },
    {
      path: '*',
      component: tw404
    },
    {
      path: '/style',
      component: style
    }
  ]
})



// WEBPACK FOOTER //
// ./src/config/router.js